import { createTranslations } from '@npco/utils-translations'

export const setupFlowAccountDetailsTranslations = createTranslations({
  copyMessage:
    'Copy details to transfer funds to your first Transaction Account.',
  accountNameDesktop: 'Your Transaction Account',
  accountNameTablet: 'Name',
  bsb: 'BSB',
  accountNumber: 'Number',
})
